import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import Swal from 'sweetalert2';
import Skeleton from 'react-loading-skeleton';
import Lightbox from 'react-image-lightbox';
import JoditEditor from "jodit-react";

import Auxiliary from '../../hoc/Auxiliary/Auxiliary';
import Button from '../../components/Button/Button';
import Select2 from "../../components/Input/Select2/Select2";
import StringInput from '../../components/Input/StringInput/StringInput';
import {formValidation, clearFormValidation, filterErrorHandler} from '../../hoc/Shared/utility';
import ValidationError from '../../components/ValidationError/ValidationError';
import Select from "../../components/Input/Select/Select";
import NumberInput from "../../components/Input/NumberInput/NumberInput";
import Tab from "../../components/Tab/Tab";
import ImageUpload from "../../components/Input/ImageUpload/ImageUpload";
import DateTimePicker from "../../components/DateTimePicker/DateTimePicker";
import moment from 'moment';

import * as actions from '../../store/ducks/rewardItem/actions';

class RewardItemCreate extends Component
{
    constructor(props)
    {
        super(props);
        this.state =
        {
            formFilter:
            {
                category_id: 1,
                status: 1,
                coin: 0.0,
                qty: 9999,
                limit: 0,
                deposit: 0,
                turnover: 0,
                round: 0,
                bet_scale: 0,
                valid_period_1: 0,
                valid_period_2: 'day',
                vendor_id: 0,
                reward_details: [],
                deposit_date_range: '',
                turnover_date_range: '',
                active_start_date: '',
                active_end_date: '',
                multiple_deposit_free_round: 0,
                setting_list: [{listIndex: Math.random(), dp: "", fr: ""}],
                game_list: [],
                selectedMemberGroups: [],
            },
            loading: true,
            langArr: [],
            errMsg: [],
            touched: false,
            dropDown:
            {
                category: [],
                vendor: [],
                gameList: [],
                memberGroups: []
            },
            image: [],
        }
        this.onInputChange = this.onInputChange.bind(this);
        this.onImageUpload = this.onImageUpload.bind(this);
        this.addRecord = this.addRecord.bind(this);
        this.handleSettingListChange = this.handleSettingListChange.bind(this);
    }

    componentDidMount()
    {
        this.props.funcGetDropDown(); // get filter drop down
        formValidation('reward_item_form');
    }

    shouldComponentUpdate(nextProps, nextState)
    {
    	const { t } = this.props;
        if (nextProps.store !== this.props.store && nextProps.store!==undefined)
        {
            if(nextProps.store.responseCode === 200 && nextProps.store.msgType === 'success')
            {
                Swal.fire({
                    icon: 'success',
                    title: t('global.success'),
                    html: t('global.record-saved'),
                    showConfirmButton: true
                }).then(() =>
                {
                    clearFormValidation('reward_item_form');
                    this.props.refreshHandler();
                    this.props.changePageHandler('listing');
                });
            }
            else
            {
                this.setState({
                    touched: true,
                    errMsg: nextProps.store.message
                });
                Swal.close();
            }
        }

        if (nextProps.dropDown !== this.props.dropDown && nextProps.dropDown!==undefined)
        {
            if(nextProps.dropDown.responseCode === 200 && nextProps.dropDown.msgType === 'success')
            {
                let newInput = Object.assign({}, this.state.formFilter);
                let categoryArr = nextProps.dropDown.data.category.map((val, idx) =>
                {
                    return {...val, category: t(`reward-category.${val.slug}`)};
                });

                let vendorArr = nextProps.dropDown.data.vendor.map((val, idx) =>
                {
                    return {...val, slug: t(`vendor.${val.slug}`)};
                });

                newInput['vendor_id'] = (nextProps.dropDown.data?.vendor[0]?.id || 0);

                const memberGroups = nextProps.dropDown.data.memberGroups.map((value) => {
                    return {
                        label: t(`global.level.${this.props.currentUser.merchant_slug}.${value.id}`, value.group_name),
                        key: value.id,
                        value: value.id,
                    }
                })

                this.setState({
                    loading: false,
                    langArr: nextProps.dropDown.data.language,
                    formFilter: newInput,
                    dropDown:
                    {
                        category: categoryArr,
                        vendor: vendorArr,
                        memberGroups,
                    },
                });
            }
            else {
                // no loading false, to prevent form submission with incomplete data
                this.setState({
                    langArr: [],
                    dropDown: {
                        category: [],
                        vendor: [],
                        memberGroups: [],
                    }
                }, () => {
                    filterErrorHandler(nextProps.dropDown.message);
                });
            }
        }

        if (nextProps.gameList !== this.props.gameList && nextProps.gameList!==undefined)
        {
            if(nextProps.gameList.responseCode === 200 && nextProps.gameList.msgType === 'success')
            {
                if(nextProps.gameList?.data?.game_list && nextProps.gameList.data.game_list.length > 0)
                {
                    let dropDown = Object.assign({}, this.state.dropDown);
                    dropDown['gameList'] = nextProps.gameList.data.game_list.map(val => ({
                        label: val.gameTitle,
                        value: val.gameCode,
                    }));

                    this.setState({
                        dropDown
                    });
                }
            }
            else 
            {
                this.setState({
                    touched: true,
                    errMsg: nextProps.gameList.message
                });
                Swal.close();
            }
        }
        
        return true;
    }

    onInputChange = (event, langId) =>
    {
        // console.log(event.target.id+' | '+event.target.value);
        let newInput = Object.assign({}, this.state.formFilter);
        if(langId && langId > 0)
        {
            if(newInput.reward_details[langId])
            {
                newInput.reward_details[langId][event.target.id] = event.target.value;
            }
            else
            {
                let newLangArr = {[event.target.id]: event.target.value};
                newInput.reward_details[langId] = newLangArr;
            }
        }
        else
        {
            newInput[event.target.id] = event.target.value;
        }

        if(event.target.id === 'category_id' && event.target.value === '2')
        {
            let data = {};
            data['vendor_id'] = this.state.formFilter.vendor_id;
            this.props.funcGameList(data);
        }

        this.setState({
            formFilter: newInput,
        });
    }

    addRecord = () => 
    {
        if(this.state.formFilter.setting_list.length < 20) 
        {
            let newInput = Object.assign({}, this.state.formFilter);
            let setting_list = [...this.state.formFilter.setting_list, {listIndex: Math.random(), dp: "", fr: ""}];
            newInput['setting_list'] = setting_list;
            this.setState({
                formFilter: newInput,
            });
        }
    };

    removeRecord = (i) => 
    {
        let newInput = Object.assign({}, this.state.formFilter);
        let setting_list = this.state.formFilter.setting_list.filter((item, idx) => i !== idx);
        newInput['setting_list'] = setting_list;
        this.setState({
            formFilter: newInput,
        });
    }

    handleSettingListChange = (event) => 
    {
        let newInput = Object.assign({}, this.state.formFilter);
        let setting_list = [...this.state.formFilter.setting_list];
        setting_list[event.target.dataset.id][event.target.name] = event.target.value;
        newInput['setting_list'] = setting_list;
        this.setState({
            formFilter: newInput,
        });
    }

    handleGameList = (event) => 
    {
        let newInput = Object.assign({}, this.state.formFilter);
        newInput['game_list'] = event;
        this.setState({
            formFilter: newInput,
        });
    }

    onImageUpload = (event, langId) =>
    {
        const {image} = this.state;
        let newInput = Object.assign({}, this.state.formFilter);
        let reader = new FileReader();
        let file = event[0];

        reader.onloadend = () =>
        {
            if(newInput.reward_details[langId])
            {
                newInput.reward_details[langId].image = reader.result;
            }
            else
            {
                let newLangArr = {'image': reader.result};
                newInput.reward_details[langId] = newLangArr;
            }
            image[langId] = file;

            this.setState({
                formFilter: newInput,
                image
            });
        };

        if (file) {
            reader.readAsDataURL(file);
        } else {
            newInput.reward_details[langId].image = '';
            image[langId] = '';
            this.setState({
                formFilter: newInput,
                image
            });
        }
    }

    onSelectMemberGroupsHandler = (event) => {
        this.setState({
            formFilter: {
                ...this.state.formFilter,
                selectedMemberGroups: event                
            }
        })
    }

    submitHandler = (e) =>
    {
        // console.log('submitHandler :', this.state);
        e.preventDefault();
        const { t } = this.props;
        Swal.fire({
            title: t('validation.confirmation'),
            text: t('validation.confirmation_check'),
            icon: 'warning',
            confirmButtonText: t('global.save'),
            showDenyButton: true,
            denyButtonText: t('global.cancel'),
        }).then((result) =>
        {
            if (result.isConfirmed)
            {
                Swal.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () =>
                    {
                        Swal.showLoading()
                    }
                });

                let formData = new FormData();

                const details = this.state.formFilter.reward_details;
                details.forEach((val, idx) =>
                {
                    for (const key in val)
                    {
                        // console.log(val[key]);
                        if(key !== 'image' && key !== 'lang_id')
                        {
                            formData.append(`${key}[${idx}]`, val[key]);
                        }
                    }
                });

                if(this.state.image.length > 0)
                {
                    const image = this.state.image;
                    image.forEach((val, idx) => {
                        formData.append("image["+idx+"]", val);
                    });
                }

                let dateRange = (this.state.formFilter.deposit_date_range!=='') ? this.state.formFilter.deposit_date_range.split(' - ') : '';
                let turnoverDateRange = (this.state.formFilter.turnover_date_range!=='') ? this.state.formFilter.turnover_date_range.split(' - ') : '';
                let actStartDate = this.state.formFilter.active_start_date ? moment(this.state.formFilter.active_start_date).format("yyyy-MM-DD HH:mm") : '';
                let actEndDate = this.state.formFilter.active_end_date ? moment(this.state.formFilter.active_end_date).format("yyyy-MM-DD HH:mm") : '';
                let data = '';
                let game_list = (Number(this.state.formFilter.category_id) === 2 && this.state.formFilter.game_list !== null && this.state.formFilter.game_list.length > 0) ? JSON.stringify(this.state.formFilter.game_list) : '';
                
                if(Number(this.state.formFilter.category_id) === 2 && Number(this.state.formFilter.multiple_deposit_free_round) === 1 && this.state.formFilter.setting_list.length > 0)
                {
                    data = this.state.formFilter.setting_list.reduce((acc, item) => 
                    {
                        acc[item.dp] = item.fr;
                        return acc;
                    }, {});

                    data = JSON.stringify(data);
                }
                
                formData.append('coin',this.state.formFilter.coin);
                formData.append('qty',this.state.formFilter.qty);
                formData.append('limit',this.state.formFilter.limit);
                formData.append('deposit',(Number(this.state.formFilter.category_id) === 2 && this.state.formFilter.multiple_deposit_free_round === '1') ? 0 : this.state.formFilter.deposit);
                formData.append('round',(Number(this.state.formFilter.category_id) === 2 && this.state.formFilter.multiple_deposit_free_round === '1') ? 0 : this.state.formFilter.round);
                formData.append('bet_scale',(Number(this.state.formFilter.category_id) !== 2) ? 0 : this.state.formFilter.bet_scale);
                formData.append('valid_period',(Number(this.state.formFilter.category_id) !== 2) ? 0 : `${this.state.formFilter.valid_period_1} ${this.state.formFilter.valid_period_2}`);
                formData.append('vendor_id',(Number(this.state.formFilter.category_id) !== 2) ? 0 : (Number(this.state.formFilter.vendor_id) === 0 && Number(this.state.formFilter.category_id) === 2) ? 1 : this.state.formFilter.vendor_id);
                formData.append('category_id',this.state.formFilter.category_id);
                formData.append('status',this.state.formFilter.status);
                formData.append('country_id',this.props.currentUser.country_id);
                formData.append('deposit_date_range', this.state.formFilter.deposit_date_range || '');
                formData.append('deposit_start_date', (this.state.formFilter.deposit_date_range !== '' && dateRange[0] !== undefined) ? `${dateRange[0]} 00:00:00` : '');
                formData.append('deposit_end_date', (this.state.formFilter.deposit_date_range !== '' && dateRange[1] !== undefined) ? `${dateRange[1]} 23:59:59` : '');                
                formData.append('active_start_date',actStartDate);
                formData.append('active_end_date',actEndDate);
                formData.append('turnover', this.state.formFilter.turnover);
                formData.append('turnover_date_range', this.state.formFilter.turnover_date_range || '');
                formData.append('turnover_start_date', (this.state.formFilter.turnover_date_range !== '' && turnoverDateRange[0] !== undefined) ? `${turnoverDateRange[0]} 00:00:00` : '');
                formData.append('turnover_end_date', (this.state.formFilter.turnover_date_range !== '' && turnoverDateRange[1] !== undefined) ? `${turnoverDateRange[1]} 23:59:59` : '');
                formData.append('data', data);
                formData.append('game_list', game_list);
                this.state.formFilter.selectedMemberGroups.forEach(item => {
                    formData.append('selected_member_groups[]', item.value || item);
                });
                this.props.funcStore(formData);
            }
        });
    }

    render()
    {
        const { t } = this.props;
        // let permission = (this.props.currentUser.permission) ? this.props.currentUser.permission : [];
        let tabMessage = null;
        let tabTitleMessage = [];
        let tabContentMessage = [];
        let statusArr = [
            { label: t("global.active"), value: 1 },
            { label: t("global.inactive"), value: 0 },
        ];
        let validPeriodArr = [
            { label: t("global.unit_of_time.day"), value: 'day' },
            { label: t("global.unit_of_time.week"), value: 'week' },
            { label: t("global.unit_of_time.month"), value: 'month' },
            { label: t("global.unit_of_time.year"), value: 'year' },
        ];
        let multipleSettingArr = [
            { label: t("global._yes"), value: 1 },
            { label: t("global.no"), value: 0 },
        ];
        let languages = this.state.langArr;
        let tabArr = (this.state.formFilter.reward_details || []);

        tabTitleMessage = languages.map((language) => language.lang);
        tabContentMessage = languages.map((item) => (
            <Auxiliary>
                {this.state.isOpen && (
                    <Lightbox
                        mainSrc={this.state.currentImage}
                        onCloseRequest={() => this.setState({ isOpen: false })}
                    />
                )}
                <div className="col-md-12">
                    <div className="form-group" key={item.langId}>
                        <label htmlFor="image">{t('reward-item.image')}</label>
                        <ImageUpload
                            id="image"
                            name={`image[${item.langId}]`}
                            onChange={(event) => this.onImageUpload(event, item.langId)}
                        />
                        {tabArr[item.langId] && tabArr[item.langId].image &&
                        <>
                            {/* <Button
                                typeButton="button"
                                classValue="clearImage"
                                buttonName="x"
                                clicked={(event) => this.onImageRemove(event, item.langId)}
                            >
                            </Button> */}
                            <div className="preview-image">
                                <img
                                    alt=""
                                    className="banner"
                                    src={tabArr[item.langId] && tabArr[item.langId].image}
                                    onClick={() => this.setState({isOpen: true, currentImage: (tabArr[item.langId].image || null)})}
                                    style={{"cursor": "pointer"}}
                                />
                                {/* <span className="text-muted"><strong>*jpg, png, gif</strong></span> */}
                            </div>
                        </>
                        }
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group">
                        <label>{t('reward-item.title')}</label>
                        <StringInput
                            onChange={(event) => this.onInputChange(event, item.langId)}
                            id="title"
                            name={`title[${item.langId}]`}
                            value={(tabArr[item.langId] && tabArr[item.langId].title) || ''}
                        />
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group">
                        <label>{t('reward-item.content')}</label>
                        <JoditEditor
                            value={(tabArr[item.langId] && tabArr[item.langId].content) || ''}
                            tabIndex={item.langId} // tabIndex of textarea
                            onBlur={newContent =>
                            {
                                let newInput = Object.assign({}, this.state.formFilter);
                                if(newInput.reward_details[item.langId])
                                {
                                    newInput.reward_details[item.langId].content = newContent;
                                }
                                else
                                {
                                    let newLangArr = {'content': newContent};
                                    newInput.reward_details[item.langId] = newLangArr;
                                }
                                newInput.reward_details[item.langId].content = newContent;

                                this.setState({
                                    formFilter: newInput
                                });
                            }}
                        />
                    </div>
                </div>
            </Auxiliary>
        ));
        tabMessage = <Tab tabNav={tabTitleMessage} tabPanel={tabContentMessage}/>;

        return (
            <Auxiliary>
                <div className="breadcrumb-header">
                    <div className='d-flex'>
                        <div className='my-auto'>
                            <Button
                                typeButton="button"
                                classValue="btn btn-back-outline"
                                idValue="back"
                                buttonName={<i className="angle fe fe-chevron-left"></i>}
                                clicked={() => this.props.changePageHandler('listing')}
                            />
                        </div>
                    </div>
                    <div className="my-auto">
                        <div className="d-flex">
                            <h4 className="content-title mb-0 my-auto ml-2">{t('reward-item.add-reward')}</h4>
                        </div>
                    </div>
                </div>
                <div className="row row-sm">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                        <div className="card  box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t('reward-item.add-reward')}</h4>
                            </div>
                            <div className="card-body pt-0">
                                {this.state.loading === true ? <Skeleton count={4}/> :
                                    <form method="post" id="reward_item_form" className="form-horizontal" encType="multipart/form-data" onSubmit={this.submitHandler} noValidate>
                                        <ValidationError formName='reward_item_form' touched={this.state.touched} message={this.state.errMsg}/>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className="col-md-12">{tabMessage}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>{t('global.status')}</label>
                                                    <Select
                                                        id="status"
                                                        name="status"
                                                        className="form-control"
                                                        options={statusArr}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        value={this.state.formFilter.status}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label >{t('reward-item.category')}</label>
                                                    <Select
                                                        id='category_id'
                                                        name='category_id'
                                                        className='form-control'
                                                        getOptionValue='id'
                                                        getOptionLabel='category'
                                                        options={this.state.dropDown.category}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        value={this.state.formFilter.category_id}
                                                        // emptyValue={true}
                                                        // required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label >{t('reward-item.coin')}</label>
                                                    <NumberInput
                                                        id='coin'
                                                        name='coin'
                                                        // min={0.01}
                                                        placeholder={t('reward-item.coin')}
                                                        value={this.state.formFilter.coin}
                                                        onKeyPress={(evt) => ((evt.key === 'e' || evt.key === '-' || evt.key === '+') && evt.preventDefault())}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        // required
                                                    />
                                                </div>
                                            </div>
                                        {/* </div> */}

                                        {/* <div className="row"> */}
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label >{t('reward-item.qty')}</label>
                                                    <NumberInput
                                                        id='qty'
                                                        name='qty'
                                                        placeholder={t('reward-item.qty')}
                                                        value={this.state.formFilter.qty}
                                                        onKeyPress={(evt) => ((evt.key === 'e' || evt.key === '-' || evt.key === '+') && evt.preventDefault())}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label >{t('reward-item.limit')}</label>
                                                    <NumberInput
                                                        id='limit'
                                                        name='limit'
                                                        placeholder={t('reward-item.limit')}
                                                        value={this.state.formFilter.limit}
                                                        onKeyPress={(evt) => ((evt.key === 'e' || evt.key === '-' || evt.key === '+') && evt.preventDefault())}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        required
                                                    />
                                                    <small>{t('reward-item.hint-no-limit')}</small>
                                                </div>
                                            </div>
                                            
                                            {
                                                (Number(this.state.formFilter.category_id) === 2 && Number(this.state.formFilter.multiple_deposit_free_round) === 0) 
                                                ? 
                                                    (
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label >{t('reward-item.deposit-amount')}</label>
                                                                <NumberInput
                                                                    id='deposit'
                                                                    name='deposit'
                                                                    placeholder={t('reward-item.deposit-amount')}
                                                                    value={this.state.formFilter.deposit}
                                                                    onKeyPress={(evt) => ((evt.key === 'e' || evt.key === '-' || evt.key === '+') && evt.preventDefault())}
                                                                    onChange={(event) => this.onInputChange(event)}
                                                                    required
                                                                />
                                                                <small>{t('reward-item.hint-not-required')}</small>
                                                            </div>
                                                        </div>
                                                    )
                                                :
                                                    (
                                                        (Number(this.state.formFilter.category_id) !== 2)
                                                        ?
                                                        (
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label >{t('reward-item.deposit-amount')}</label>
                                                                    <NumberInput
                                                                        id='deposit'
                                                                        name='deposit'
                                                                        placeholder={t('reward-item.deposit-amount')}
                                                                        value={this.state.formFilter.deposit}
                                                                        onKeyPress={(evt) => ((evt.key === 'e' || evt.key === '-' || evt.key === '+') && evt.preventDefault())}
                                                                        onChange={(event) => this.onInputChange(event)}
                                                                        required
                                                                    />
                                                                    <small>{t('reward-item.hint-not-required')}</small>
                                                                </div>
                                                            </div>
                                                        )
                                                        :
                                                        null
                                                    )
                                            }
                                            
                                        {/* </div> */}

                                        {/* <div className="row"> */}
                                            <div className='col-md-4'>
                                                <div className="form-group">
                                                    <label>
                                                        {t('reward-item.deposit-date-range')}
                                                    </label>
                                                    <DateTimePicker
                                                        id="deposit_date_range"
                                                        name="deposit_date_range"
                                                        className="form-control filter-input"
                                                        format="YYYY-MM-DD"
                                                        // singleDatePicker={true}
                                                        // autoUpdateInput={true}
                                                        range={true}
                                                        autoApply={false}
                                                        value={this.state.formFilter.deposit_date_range}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        // required={true}
                                                    />
                                                </div>
                                            </div>   
                                                                                    
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label >{t('reward-item.turnover-amount')}</label>
                                                    <NumberInput
                                                        id='turnover'
                                                        name='turnover'
                                                        placeholder={t('reward-item.turnover-amount')}
                                                        value={this.state.formFilter.turnover}
                                                        onKeyPress={(evt) => ((evt.key === 'e' || evt.key === '-' || evt.key === '+') && evt.preventDefault())}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        // required
                                                    />
                                                    <small>{t('reward-item.hint-not-required')}</small>
                                                </div>
                                            </div>
                                        
                                            <div className='col-md-4'>
                                                <div className="form-group">
                                                    <label>
                                                        {t('reward-item.turnover-date-range')}
                                                    </label>
                                                    <DateTimePicker
                                                        id="turnover_date_range"
                                                        name="turnover_date_range"
                                                        className="form-control filter-input"
                                                        format="YYYY-MM-DD"
                                                        // singleDatePicker={true}
                                                        // autoUpdateInput={true}
                                                        range={true}
                                                        autoApply={false}
                                                        value={this.state.formFilter.turnover_date_range}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        // required={true}
                                                    />
                                                </div>
                                            </div>
                                            
                                            {Number(this.state.formFilter.category_id) === 2 && (
                                                <>
                                                    {Number(this.state.formFilter.category_id) === 2 && Number(this.state.formFilter.multiple_deposit_free_round) === 0 && (
                                                    <div className='col-md-4'>
                                                        <div className='form-group'>
                                                            <label>
                                                                {t('reward-item.free-round')}
                                                            </label>
                                                            <NumberInput
                                                                id='round'
                                                                name='round'
                                                                placeholder={t('reward-item.free-round')}
                                                                value={this.state.formFilter.round}
                                                                onKeyPress={(evt) => ((evt.key === 'e' || evt.key === '-' || evt.key === '+') && evt.preventDefault())}
                                                                onChange={(event) => this.onInputChange(event)}
                                                            />
                                                        </div>
                                                    </div>)}
                                            
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label >{t('reward-item.bet-scale')}</label>
                                                            <NumberInput
                                                                id='bet_scale'
                                                                name='bet_scale'
                                                                placeholder={t('reward-item.bet-scale')}
                                                                value={this.state.formFilter.bet_scale}
                                                                onKeyPress={(evt) => ((evt.key === 'e' || evt.key === '-' || evt.key === '+') && evt.preventDefault())}
                                                                onChange={(event) => this.onInputChange(event)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label >{t('reward-item.valid-period')}</label>
                                                            <div className="input-group">
                                                                <NumberInput
                                                                    id='valid_period_1'
                                                                    name='valid_period_1'
                                                                    placeholder={t('reward-item.valid-period')}
                                                                    value={this.state.formFilter.valid_period_1}
                                                                    onKeyPress={(evt) => ((evt.key === 'e' || evt.key === '-' || evt.key === '+') && evt.preventDefault())}
                                                                    onChange={(event) => this.onInputChange(event)}
                                                                    // style={{ width: '50px', }}
                                                                />
                                                                <span style={{ margin: "auto 10px", }}>&nbsp;</span>
                                                                <Select
                                                                    id="valid_period_2"
                                                                    name="valid_period_2"
                                                                    className="form-control"
                                                                    options={validPeriodArr}
                                                                    onChange={(event) => this.onInputChange(event)}
                                                                    value={this.state.formFilter.valid_period_2}
                                                                />
                                                                <span style={{ margin: "auto 50px", width: '50px', }}>&nbsp;</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label >{t('reward-item.vendor')}</label>
                                                            <Select
                                                                id='vendor_id'
                                                                name='vendor_id'
                                                                className='form-control'
                                                                getOptionValue='id'
                                                                getOptionLabel='slug'
                                                                options={this.state.dropDown.vendor}
                                                                onChange={(event) => this.onInputChange(event)}
                                                                value={this.state.formFilter.vendor_id}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label >{t('reward-item.game-list')}</label>
                                                            <Select2
                                                                id="active_day"
                                                                name="active_day"
                                                                options={this.state.dropDown.gameList || []}
                                                                className="form-control"
                                                                onChange={this.handleGameList}
                                                                value={this.state.formFilter.game_list}
                                                                placeholder={t('global.select')}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label>{t('reward-item.multi-dp-fr')}</label>
                                                            <Select
                                                                id="multiple_deposit_free_round"
                                                                name="multiple_deposit_free_round"
                                                                className="form-control"
                                                                options={multipleSettingArr}
                                                                onChange={(event) => this.onInputChange(event)}
                                                                value={this.state.formFilter.multiple_deposit_free_round}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label >{t('reward-item.start-time')}</label>
                                                    <DateTimePicker
                                                        id="active_start_date"
                                                        name="active_start_date"
                                                        className="form-control filter-input"
                                                        singleDatePicker={true}
                                                        timePicker={true}
                                                        value={this.state.formFilter.active_start_date}
                                                        onChange={this.onInputChange}
                                                        required={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label >{t('reward-item.end-time')}</label>
                                                    <DateTimePicker
                                                        id="active_end_date"
                                                        name="active_end_date"
                                                        className="form-control filter-input"
                                                        singleDatePicker={true}
                                                        timePicker={true}
                                                        value={this.state.formFilter.active_end_date}
                                                        onChange={this.onInputChange}
                                                        required={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label >{t('reward-item.eligible-member-groups')}</label>
                                                    <Select2
                                                        options={this.state.dropDown.memberGroups}
                                                        name="memberGroups"
                                                        onChange={this.onSelectMemberGroupsHandler}
                                                        value={this.state.formFilter.selectedMemberGroups}
                                                        menuPlacement="top"
                                                        placeholder={t('global.please-select')}
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                        <br/>
                                        {Number(this.state.formFilter.category_id) === 2 && Number(this.state.formFilter.multiple_deposit_free_round) === 1 && (
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className='row'>
                                                    <h3 className="card-title col-8">{t('reward-item.multi-dp-fr')}</h3>
                                                    <div className="row col-4 justify-content-end mb-2 pr-0">
                                                        <button type="button" className="btn btn-info" onClick={(e) => this.addRecord(e)}>
                                                            <i className="fa fa-plus"></i> {t('lucky-spin-setting.add')}
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="table-responsive" style={{overflowY:'auto'}}>
                                                    <table className="table" id="setting_table" style={{minWidth:500}}>
                                                        <thead className="text-center bg-primary">
                                                            <tr>
                                                                <th className="text-white p-2">{t('global.no')}</th>
                                                                <th className="text-white p-2">{t('reward-item.deposit-amount')}</th>
                                                                <th className="text-white p-2">{t('reward-item.free-round')}</th>
                                                                <th style={{ width: "5%" }}>&nbsp;</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.formFilter.setting_list.map((item, idx) => {
                                                                return (
                                                                    <tr key={idx} className="text-center">
                                                                        <td>{idx + 1}</td>
                                                                        <td key={`dp-${idx}`}>
                                                                            <input
                                                                                id="dp"
                                                                                name="dp"
                                                                                data-id={idx}
                                                                                className="form-control"
                                                                                placeholder={t('reward-item.deposit-amount')}
                                                                                value={item.dp}
                                                                                onChange={this.handleSettingListChange}
                                                                                autoComplete="off"
                                                                            />
                                                                        </td>
                                                                        <td key={`fr-${idx}`}>
                                                                            <input
                                                                                id="fr"
                                                                                name="fr"
                                                                                data-id={idx}
                                                                                className="form-control"
                                                                                placeholder={t('reward-item.free-round')}
                                                                                value={item.fr}
                                                                                onChange={this.handleSettingListChange}
                                                                                autoComplete="off"
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <i className="fa fa-trash" style={{color:'red', cursor:'pointer'}} onClick={() => this.removeRecord(idx)}></i>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>)}

                                        <div className="form-group mb-0 justify-content-end">
                                            <div>
                                                <Button
                                                    id="submit"
                                                    classValue="btn btn-blue"
                                                    typeButton="submit"
                                                    buttonName={t('global.save')}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = state =>
{
    return {
        store: state.rewardItem.store,
        dropDown: state.rewardItem.dropDown,
        currentUser: state.currentUser.data,
        gameList: state.rewardItem.gameList,
    }
};

//Using the redux calling api methods
const mapDispatchToProps = dispatch =>
{
    return {
        funcStore: (data) => dispatch(actions.store(data)),
        funcGetDropDown: () => dispatch(actions.getDropDown()),
        funcGameList: (data) => dispatch(actions.getGameList(data)),
    }
};

// Connect redux
export default connect(mapStateToProps, mapDispatchToProps) (withNamespaces('translation')(RewardItemCreate));